import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsSalesByCityQuery } from "../graphql/queries";
import type {
  AnalyticsSalesByCityQueryType,
  AnalyticsSalesByCityQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsSalesByCityQuery = (
  options?: QueryHookOptions<
    AnalyticsSalesByCityQueryType,
    AnalyticsSalesByCityQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsSalesByCityQueryType,
    AnalyticsSalesByCityQueryVariablesType
  >(AnalyticsSalesByCityQuery, options);
};
